import {
  Download,
  History,
  DatabaseBackup,
  KeyRound,
  Scale,
} from "lucide-react";
import { useSectionViewGoal } from "@/hooks/useSectionViewGoal";
import { CONTAINER } from "./ui-tokens";

// Esta seção responde às perguntas que decidem a contratação em igrejas
// maiores: portabilidade, rastreabilidade, backup, permissão e LGPD.
// Regra ao editar: só entra aqui o que existe hoje no sistema. Nada de
// funcionalidade planejada — é justamente a seção que sustenta a confiança.
const guarantees = [
  {
    icon: Download,
    title: "Você leva seus dados quando quiser",
    desc: "Exportação da lista de membros, exportação contábil em CSV ou Excel para o contador e relatórios prontos para baixar. Se um dia a igreja decidir sair, sai com a base na mão.",
  },
  {
    icon: History,
    title: "Registro de tudo que muda",
    desc: "As alterações em pessoas, finanças, escalas e eventos ficam registradas com quem fez, o que mudou e quando. Importa sobretudo no financeiro, quando a tesouraria tem mais de uma pessoa.",
  },
  {
    icon: KeyRound,
    title: "Cada líder vê só o que é dele",
    desc: "O líder de célula acompanha o próprio grupo, o de ministério a própria equipe, a tesouraria o financeiro. O pastor enxerga o conjunto.",
  },
  {
    icon: DatabaseBackup,
    title: "Backup diário, infraestrutura Google",
    desc: "O sistema roda em Google Cloud / Firebase, com backup automático todos os dias e criptografia em trânsito e em repouso.",
  },
  {
    icon: Scale,
    title: "LGPD levada a sério",
    desc: "Dados pessoais, familiares, financeiros e pastorais tratados conforme a LGPD. A igreja pode pedir a exclusão da base a qualquer momento.",
  },
];

export default function DataTrust() {
  const ref = useSectionViewGoal("data_trust");

  /* Esta seção já usou `content-visibility: auto`. Foi removido de propósito:
     ela fica ACIMA de #precos, o destino de quase todo CTA da landing, e a
     altura estimada nunca bate com a real. Não reintroduza aqui sem resolver
     isso (ver case-ieq.tsx). */
  return (
    <section
      ref={ref}
      id="seguranca"
      aria-labelledby="seguranca-titulo"
      className="py-20 md:py-24"
    >
      {/* Seção curta de propósito: quem chega aqui já quer o produto e só
          precisa saber que pode confiar a base da igreja a ele. Título menor,
          as cinco garantias e nada de respiro de seção de argumento. */}
      <div className={`${CONTAINER} grid gap-10 lg:grid-cols-12 lg:gap-16`}>
        <div className="lp-reveal lg:col-span-4">
          <h2
            id="seguranca-titulo"
            className="text-2xl font-semibold tracking-tight text-balance text-foreground md:text-3xl"
          >
            Os dados da sua igreja são da sua igreja.{" "}
            <span className="text-muted-foreground">Não nossos.</span>
          </h2>
        </div>

        <ul className="grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:col-span-8">
          {guarantees.map((item) => (
            <li key={item.title} className="lp-reveal flex gap-4">
              <item.icon
                className="mt-0.5 size-5 shrink-0 text-primary"
                strokeWidth={1.75}
                aria-hidden="true"
              />
              <div>
                <h3 className="font-semibold text-foreground">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                  {item.desc}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
